/* eslint-disable @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface */
/** WARNING: This file is generated automatically **/

import type { TrackingContextValue } from '../providers/TrackingContext';
import { getEntities } from '../utils/getEntities';
import { getGTMData } from '../utils/getGTMData';
import { trackSelfDescribingEvent } from '../utils/trackSelfDescribingEvent';

/**
 * triggers when the user clicks on a crm zone
 */
export interface CrmZoneClick {
  /**
   * the action the zone triggers when the user clicks on it
   */
  action: 'navigate' | 'login' | 'sign_up' | 'open_account' | 'open_crm_modal' | 'launch_game';
}

export const crmZoneClick = (data: Readonly<CrmZoneClick>, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'crm_zone_click', ...data, ...getGTMData(context) });

  trackSelfDescribingEvent(
    {
      event: {
        schema: 'iglu:com.starsgroup/crm_zone_click/jsonschema/2-0-0',
        data
      },
      context: getEntities(context)
    },
    context
  );
};
